/* eslint-disable @typescript-eslint/no-unsafe-assignment */

/* eslint-disable @typescript-eslint/no-explicit-any */
import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    EmbeddedViewRef,
    HostBinding,
    Input,
    OnDestroy,
    TemplateRef,
    ViewChild,
    ViewContainerRef,
} from '@angular/core';

import { assign } from 'lodash-es';

@Component({
    selector: 'ms-swipe-actions',
    template: '<ng-container #container></ng-container>',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwipeActionsComponent implements AfterViewInit, OnDestroy {
    @Input() set context(value: any) {
        this.viewContext = value;

        if (this.view) {
            assign(this.view.context, this.viewContext);

            this.view.detectChanges();
        }
    }

    @Input() template: TemplateRef<any>;
    @HostBinding('class') className = 'swipe-actions';
    @ViewChild('container', { read: ViewContainerRef }) container: ViewContainerRef;

    private view: EmbeddedViewRef<any>;
    private viewContext: any;

    isComponentDestroyed = false;

    ngAfterViewInit(): void {
        this.view = this.container.createEmbeddedView(this.template, this.viewContext);
        this.view.detectChanges();
    }

    ngOnDestroy(): void {
        this.isComponentDestroyed = true;
    }
}
